import SFFileImportRoute from './SFFileImportRoute';

export default {
  name: 'SFFileImportRoute',
  location: '/sf/file-import',
  component: SFFileImportRoute,
};
